import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useHelpModalState } from 'react-commons';
import { SyntheticEvent, useState } from 'react';
import { useGlobalState } from '../../../state/persistence';
import { useStyles } from '../../Shared';

const useAdditionalPayment = (nextUrl: string) => {
  const { t } = useTranslation('additional_payment');
  const history = useHistory();
  const { dispatchQuestion } = useGlobalState();
  const { toggleHelpModal } = useHelpModalState();

  const [amount, setAmount] = useState<string>('');

  const onAmountChange = (e: SyntheticEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    setAmount(target.value);
  };

  const onSubmit = () => {
    dispatchQuestion('paymentAmount', `-${amount}`);
    history.push(Array.isArray(nextUrl) ? nextUrl[0] : nextUrl);
  };

  const onSkip = () => {
    dispatchQuestion('paymentAmount', '');
    history.push(nextUrl);
  };

  return {
    classes: useStyles(),
    t,
    onAmountChange,
    onSubmit,
    toggleHelpModal,
    onSkip,
    amount,
  };
};

export default useAdditionalPayment;
